module.exports = __webpack_public_path__ + "static/media/icon_menu.e91108f4.svg";